import { useState } from 'react';
import { Box, IconButton, SwipeableDrawer } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import Sidebar from './Sidebar';
import ChatArea from './ChatArea';
import LoginModal from './LoginModal';
import useResponsive from '../hooks/useResponsive';
import { colors } from '../theme';

export default function AppLayout({
  conversations,
  selectedConversation,
  messages,
  isStreaming,
  sidebarCollapsed,
  loginModalOpen,
  onConversationSelect,
  onNewChat,
  onRenameConversation,
  onDeleteConversation,
  onSendMessage,
  onSidebarToggle,
  onCloseLoginModal,
}) {
  const { isMobile } = useResponsive();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const handleConversationSelect = (conv) => {
    onConversationSelect(conv);
    if (isMobile) {
      setMobileSidebarOpen(false);
    }
  };

  const handleNewChat = async () => {
    await onNewChat();
    if (isMobile) {
      setMobileSidebarOpen(false);
    }
  };

  if (isMobile) {
    return (
      <>
        <Box sx={{
          display: 'flex',
          height: '100vh',
          width: '100vw',
          overflow: 'hidden',
          position: 'relative',
        }}>
          <SwipeableDrawer
            anchor="left"
            open={mobileSidebarOpen}
            onClose={() => setMobileSidebarOpen(false)}
            onOpen={() => setMobileSidebarOpen(true)}
            disableSwipeToOpen={false}
            sx={{
              '& .MuiDrawer-paper': {
                width: '85vw',
                maxWidth: '320px',
                boxSizing: 'border-box',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                overflow: 'hidden',
              },
            }}
          >
            <Sidebar
              conversations={conversations}
              selectedConversation={selectedConversation}
              onConversationSelect={handleConversationSelect}
              onNewChat={handleNewChat}
              onRenameConversation={onRenameConversation}
              onDeleteConversation={onDeleteConversation}
              collapsed={false}
              isMobile={true}
              onCloseMobile={() => setMobileSidebarOpen(false)}
            />
          </SwipeableDrawer>

          {mobileSidebarOpen && (
            <Box
              onClick={() => setMobileSidebarOpen(false)}
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 1200,
              }}
            />
          )}

          <ChatArea
            messages={messages}
            onSendMessage={onSendMessage}
            isStreaming={isStreaming}
            currentConversation={selectedConversation}
            isMobile={true}
            onOpenSidebar={() => setMobileSidebarOpen(true)}
            onNewChat={handleNewChat}
          />
        </Box>
        <LoginModal
          open={loginModalOpen}
          onClose={onCloseLoginModal}
        />
      </>
    );
  }

  return (
    <>
      <Sidebar
        conversations={conversations}
        selectedConversation={selectedConversation}
        onConversationSelect={onConversationSelect}
        onNewChat={onNewChat}
        onRenameConversation={onRenameConversation}
        onDeleteConversation={onDeleteConversation}
        collapsed={sidebarCollapsed}
      />
      <ChatArea
        messages={messages}
        onSendMessage={onSendMessage}
        isStreaming={isStreaming}
        currentConversation={selectedConversation}
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebar={onSidebarToggle}
        onNewChat={onNewChat}
      />
      <LoginModal
        open={loginModalOpen}
        onClose={onCloseLoginModal}
      />
    </>
  );
}
